module.exports = __webpack_public_path__ + "static/media/professional-reviewing-car-certification-illustration-svg-download-png-14037616.png 2.2cfc798c.svg";